import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

/**
 * Wrap protected routes. If no user/token — redirect to /login.
 * Does NOT call navigate() during render — uses <Navigate /> declaratively,
 * so hooks order stays stable and React does not unmount mid-render.
 */
export function RequireAuth({ children }: { children: ReactNode }): JSX.Element {
  const { user, token } = useAuth();
  const location = useLocation();
  if (!user || !token) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
